// apps/web/src/components/ui/ErrorState.tsx
import { useT } from "../../lib/i18n";
import { Button } from "./Button";

export function ErrorState({ message, onRetry }: { message: string; onRetry?: () => void }) {
  const t = useT();
  return (
    <div className="text-center mt-16 space-y-4 px-4">
      <p className="text-fg-muted text-sm">{message}</p>
      {onRetry && <Button variant="secondary" onClick={onRetry}>{t("common.retry")}</Button>}
    </div>
  );
}
